/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StorageDownloadLinkResponseDto
 */
export interface StorageDownloadLinkResponseDto {
    /**
     * 
     * @type {string}
     * @memberof StorageDownloadLinkResponseDto
     */
    downloadLink: string;
}

/**
 * Check if a given object implements the StorageDownloadLinkResponseDto interface.
 */
export function instanceOfStorageDownloadLinkResponseDto(value: object): value is StorageDownloadLinkResponseDto {
    if (!('downloadLink' in value) || value['downloadLink'] === undefined) return false;
    return true;
}

export function StorageDownloadLinkResponseDtoFromJSON(json: any): StorageDownloadLinkResponseDto {
    return StorageDownloadLinkResponseDtoFromJSONTyped(json, false);
}

export function StorageDownloadLinkResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorageDownloadLinkResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'downloadLink': json['downloadLink'],
    };
}

export function StorageDownloadLinkResponseDtoToJSON(json: any): StorageDownloadLinkResponseDto {
    return StorageDownloadLinkResponseDtoToJSONTyped(json, false);
}

export function StorageDownloadLinkResponseDtoToJSONTyped(value?: StorageDownloadLinkResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'downloadLink': value['downloadLink'],
    };
}

